var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"justify":"center","align":"center"}},[_c('div',[_vm._v("404 PAGE NOT")]),_c('div',[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("Go Home")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }